import { createForUser } from '@license-manager/casl-rules';

export default createForUser({});
